import { Injectable, signal } from '@angular/core';
import { makeSafeReplacer } from '../utils/safe-json';

export interface Web3ErrorEntry {
  id: number;
  message: string;
}

const MAX_ERRORS = 5;

@Injectable({ providedIn: 'root' })
export class Web3ErrorService {
  private nextId = 1;
  private _errors = signal<Web3ErrorEntry[]>([]);
  readonly errors = this._errors.asReadonly();

  pushError(err: unknown): void {
    const message = stringifyError(err);
    if (!message) return;
    const entry: Web3ErrorEntry = { id: this.nextId++, message };
    this._errors.update((list) => [...list.slice(-(MAX_ERRORS - 1)), entry]);
  }

  dismiss(id: number): void {
    this._errors.update((list) => list.filter((e) => e.id !== id));
  }
}

function stringifyError(err: unknown): string {
  if (err == null) return '';
  if (err instanceof Error) {
    const name = err.name || 'Error';
    return err.message ? `${name}: ${err.message}` : name;
  }
  if (typeof err === 'object') {
    try { return JSON.stringify(err, makeSafeReplacer(), 2); } catch { return String(err); }
  }
  return String(err);
}
